import { Injectable } from '@angular/core';
import { URLS } from '../constants/constants';
import { HeaderType } from '../enums/enums';
import { FilterModel } from '../interface/interface';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  constructor(private http: HttpService) {}

  getCategoryList(filter: FilterModel) {
    return this.http.get(`${URLS.category}`, {
      params: {
        headerType: HeaderType.ACCESS,
        search: filter.searchText,
        page: filter.pageNumber,
        limit: filter.limit,
      },
    });
  }

  getCategory(id: string) {
    return this.http.get(`${URLS.category}/${id}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }
  addCategory(payload: { name: string }) {
    return this.http.post(`${URLS.category}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  updateCategory(id: string, payload: { name: string; pageTitle: string }) {
    return this.http.put(`${URLS.category}/${id}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  deleteCategory(id: string) {
    return this.http.delete(`${URLS.category}/${id}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }
}
